module.exports = __webpack_public_path__ + "img/02.b3beb8bb.png";